@if (policy.value()) {
  <pre>{{policy.value() | json}}</pre>
}
